export function getName (host) {
	return host.constructor === Object ? host.name : host
}

export function getType ({ property, definitions }) {
	return definitions[property.definitionName] && definitions[property.definitionName].type
}

export function isMatch ({ property, definitions }) {
	return getType({ property, definitions }) === 'String' || property.path === 'tx'
}

export function isBoolean ({ property, definitions }) {
	return getType({ property, definitions }) === 'Boolean'
}

export function isRange ({ property, definitions }) {
	return ['Integer', 'Long', 'Amount', 'Timestamp'].includes(getType({ property, definitions })) && property.path !== 'tx'
}

export function isTimestamp ({ property, definitions }) {
	return getType({ property, definitions }) === 'Timestamp'
}
